import { IAddPermission, IPermissionListSearch, SetAuthorityInUser, SetPermissionById } from "../../../types/permissions/permissionInterface";
import { PermissionActionTypes, PermissionActions } from "../../actionTypes/permissions/permissionTypes";


export const getPermissionList = (payload: IPermissionListSearch): PermissionActionTypes => ({
  type: PermissionActions.GET_PERMISSION_LIST,
  payload
});

export const setPermissionList = (payload: any): PermissionActionTypes => ({
  type: PermissionActions.SET_PERMISSION_LIST,
  payload
})

export const setPermissionListCount = (payload: number): PermissionActionTypes => ({
  type: PermissionActions.SET_PERMISSION_PAGE_COUNT,
  payload
})

export const addPermission = (payload: IAddPermission): PermissionActionTypes => ({
  type: PermissionActions.ADD_PERMISSION,
  payload
})

export const getPermissionsByUserId = (userId: string): PermissionActionTypes => ({
  type: PermissionActions.GET_PERMISSION_BY_USERID,
  payload: userId
})

export const setPermissionByUserId = (payload: SetPermissionById): PermissionActionTypes => ({
  type: PermissionActions.SET_PERMISSION_BY_USERID,
  payload
})

export const setPermissionsInUser = (payload: SetAuthorityInUser): PermissionActionTypes => ({
  type: PermissionActions.SET_PERMISSION_IN_USER,
  payload
})

export const getPermissionDropdownList = (payload: any): PermissionActionTypes => ({
  type: PermissionActions.GET_PERMISSION_DROPDOWN_LIST,
  payload
});

export const setPermissionDropdownList = (payload: any): PermissionActionTypes => ({
  type: PermissionActions.SET_PERMISSION_DROPDOWN_LIST,
  payload
})

export const setPermissionDropdownLoading = (payload: any): PermissionActionTypes => ({
  type: PermissionActions.SET_PERMISSION_DROPDOWN_LOADING,
  payload
})